var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M57 6.6H7C3.6 6.6.7 9.4.7 12.9v26.4c0 3.4 2.8 6.3 6.3 6.3h22.8V53h-11c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h26.4c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3H34.3v-7.4H57c3.4 0 6.3-2.8 6.3-6.3V12.8c0-3.4-2.9-6.2-6.3-6.2m1.8 32.6c0 1-.8 1.8-1.8 1.8H7c-1 0-1.8-.8-1.8-1.8V12.8c0-1 .8-1.8 1.8-1.8h50c1 0 1.8.8 1.8 1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.1 20.4h4c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3h-4c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2c.9 0 1.7.8 1.7 1.7s-.8 1.7-1.7 1.7h-4c-1.2 0-2.3 1-2.3 2.3c0 1.2 1 2.3 2.3 2.3h4c3.4 0 6.2-2.8 6.2-6.2s-2.8-6.2-6.2-6.2c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7m15.8 0h4c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3h-4c-3.4 0-6.2 2.8-6.2 6.2v8c0 3.4 2.8 6.2 6.2 6.2h4c1.2 0 2.3-1 2.3-2.3c0-1.2-1-2.3-2.3-2.3h-4c-.9 0-1.7-.8-1.7-1.7v-1.7h5.7c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3h-5.7v-1.7c0-.8.8-1.5 1.7-1.5m17-4.5h-2.3c-2.8 0-5.1 2.3-5.1 5.1v10.2c0 2.8 2.3 5.1 5.1 5.1h2.3c2.8 0 5.1-2.3 5.1-5.1V20.9c-.1-2.8-2.3-5-5.1-5m.5 15.2c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6V20.9c0-.3.3-.6.6-.6h2.3c.3 0 .6.3.6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.e0782e93407d8560ab730d9cc39d05e4.svg";
export { ForwardRef as ReactComponent };